import React from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, ArrowLeft, Tag, ArrowRight } from "lucide-react";
import { articles } from "../data/articles";

const ArticlePage = () => {
  const { slug } = useParams();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div className="min-h-screen pt-32 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-3xl font-bold text-[#1A1A2E]">Article non trouvé</h1>
          <p className="text-[#1A1A2E]/60 mt-4">
            {"Cet article n'existe pas ou a été déplacé."}
          </p>
          <Link
            to="/ressources"
            className="inline-flex items-center gap-2 mt-6 text-[#C4956A] font-medium hover:gap-3 transition-all"
          >
            <ArrowLeft className="w-4 h-4" /> Retour aux ressources
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      {/* Hero */}
      <section className="pt-32 pb-8 bg-[#FAF9F6]">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link
              to="/ressources"
              className="inline-flex items-center gap-2 text-sm text-[#C4956A] font-medium hover:gap-3 transition-all mb-6"
            >
              <ArrowLeft className="w-4 h-4" /> Retour aux ressources
            </Link>
            <div className="flex items-center gap-3 mb-4">
              <span className="px-3 py-1 bg-[#C4956A]/10 text-[#C4956A] text-xs font-medium rounded-full flex items-center gap-1">
                <Tag className="w-3 h-3" /> {article.categorie}
              </span>
              <span className="text-xs text-[#1A1A2E]/40 flex items-center gap-1">
                <Calendar className="w-3 h-3" /> {article.date}
              </span>
            </div>
            <h1 className="text-3xl lg:text-4xl font-bold text-[#1A1A2E] leading-tight">
              {article.titre}
            </h1>
            <p className="text-lg text-[#1A1A2E]/60 mt-4">{article.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Image */}
      <section className="pb-8 bg-[#FAF9F6]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <img
              src={article.image}
              alt={article.titre}
              className="w-full h-80 lg:h-96 object-cover rounded-2xl shadow-lg"
            />
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="prose prose-lg max-w-none"
            style={{
              color: "#1A1A2E",
              lineHeight: "1.8",
            }}
          >
            <div
              dangerouslySetInnerHTML={{ __html: article.contenu }}
              className="article-content"
            />
          </motion.div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#FAF9F6]">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <div className="bg-[#1A1A2E] rounded-2xl p-8 lg:p-10 text-center">
            <h3 className="text-2xl font-bold text-white">
              {"Prêt à investir à"} <span className="text-[#C4956A]">Marseille</span> ?
            </h3>
            <p className="text-white/60 mt-2">
              {"Contactez-nous pour un échange gratuit et sans engagement."}
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 mt-6 px-8 py-3.5 bg-[#C4956A] text-white font-medium rounded-lg hover:bg-[#B38459] transition-all"
            >
              Prendre rendez-vous
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArticlePage;
